(function () {
    'use strict';

    angular.module("imApp").factory("metaTableDataDetailService", ['$ihttp', function ($ihttp) {
        var service = {
            getMetaTableDataDetail: function (parms) {
                return $ihttp.post({
                    method: 2420,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();